import { Box, Container, Tab, Tabs } from "@mui/material";
import React, { SyntheticEvent, useState } from "react";
import { Layout } from "../SharedComponents/Layout";
import {
  getUserRolesFromToken,
  RolesEnum,
} from "../utils/getUserRolesFromToken";
import AllUsersTab from "./components/AllUsersTab/AllUsersTab";
import InvitedUsersTab from "./components/InvitedUsersTab/InvitedUsersTab";
import ResellersTab from "./components/ResellersTab/ResellersTab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-management-tabpanel-${index}`}
      aria-labelledby={`user-management-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default function UserManagementPage() {
  const [value, setValue] = useState(0);
  const userRoles = getUserRolesFromToken();
  const isAdmin = userRoles.includes(RolesEnum.ADMIN);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="user management tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            centered={false}
          >
            <Tab label="Respondentes" id="user-management-tab-0" />
            {isAdmin && (
              <Tab label="Todos os Usuários" id="user-management-tab-1" />
            )}
            {isAdmin && <Tab label="Revendedores" id="user-management-tab-2" />}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <InvitedUsersTab />
        </TabPanel>
        {isAdmin && (
          <TabPanel value={value} index={1}>
            <AllUsersTab />
          </TabPanel>
        )}
        {isAdmin && (
          <TabPanel value={value} index={2}>
            <ResellersTab />
          </TabPanel>
        )}
      </Container>
    </Layout>
  );
}
